export const apiRoutes = {
  createContact: "/contact/create",
  ListContacts: "/contact/getall",
  FetchContact: "/getone/:id",
};
